import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ChannelClient } from 'api/clients/ChannelClient'
import { ChannelMember } from 'types'

interface Props {
  enabled: boolean
  groupId?: number
}

export const useGroupMembers = ({ groupId, enabled }: Props) => {
  return useQuery<ChannelMember[]>(
    ['groups', groupId, 'members'],
    async () => {
      if (!groupId) return []

      const res = await ChannelClient.getChannelMembers(groupId)

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data.channel_memberships
    },
    {
      refetchOnWindowFocus: false,
      enabled,
      staleTime: 2 * 60 * 1000, // 2 minutes
    },
  )
}
